import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';

export const filesDocumentsDriverObj = (dispatch) => {
    const driverObj = driver({
        showProgress: true,
        nextBtnText: 'Next',
        prevBtnText: 'Previous',
        doneBtnText: 'Done',
        popoverClass: 'driverjs-theme',
        steps: [
            {
                element: '.uploadFiles',
                popover: {
                    title: 'Upload Files',
                    description: 'Click here to upload new files. Supports various file formats including PDF, DOC, DOCX, and more.',
                    side: 'left',
                    align: 'start',
                },
            },
            {
                element: '.searchDocuments',
                popover: {
                    title: 'Search Documents',
                    description: 'Quickly find documents by searching through titles, content, and metadata.',
                    side: 'top',
                    align: 'start',
                },
            },
            {
                element: '.documentAndFoldersPreview',
                popover: {
                    title: 'Document and Folders Preview',
                    description: 'Helps you quickly verify document contents.',
                    side: 'right',
                    align: 'start',
                },
            },
            {
                element: '.filesBreadcrumb',
                popover: {
                    title: 'Files Breadcrumb',
                    description: 'Helps you navigate through the files and folders.',
                },
            },
            {
                element: '.filesHome',
                popover: {
                    title: 'Files Home',
                    description: 'Helps you navigate to the main Folder of the company/site.',
                },
            },
            {
                element: '.filesArchive',
                popover: {
                    title: 'Files Archive',
                    description: 'Click here to open the Archive Files/Folders of the company/site.',
                },
            },
            {
                element: '.filesActions',
                popover: {
                    title: 'Files Actions',
                    description: 'If User is allowed from Rbac, they can perform actions on files and folders.',
                },
            },
        ],
    });
    return driverObj;
};

export default filesDocumentsDriverObj;
